import type { DataGroupCopyDto } from "../../types/DataGroupCopyDto";
import type { DataGroupCopyEntity } from "../../types/DataGroupCopyEntity";

export const DataGroupCopyEntityToCopyDto = ({ ...rest }: Readonly<DataGroupCopyEntity>): DataGroupCopyDto => {
    return { ...rest };
};
